export const handelChangeListMoreProducts = (listMoreProducts) => ({
    type: 'CHANGE_LIST_MORE_PRODUCTS',listMoreProducts
});